import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import "./AllPostAdmin.css";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { EditPost } from "./allPostAdminEdit";

function TicketFeedbackAdmin({ match }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [selectedData, setSelectedData] = useState({});

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  const getPosts = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const postData = await api.getTicketFeedback(payload);
      setData(postData.feedbacks || []);
      setnoOfPost(postData.totalFeedbacks || 0);
      setLimit(postData.limit || 10);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setData([]);
      setnoOfPost(0);
    }
  };

  useEffect(() => {
    getPosts();
  }, [page]);

  return (
    <>
      <div className="container-fluid crypto-trades-admin">
        {/* Header Section */}
        <div className="crypto-trades-header">
          <div className="content-of-header">
            <div className="title-section">
              <h1 className="crypto-trades-title">
                <i className="fa-regular fa-star crypto-trades-icon"></i>
                Ticket Feedback ({noOfPost})
              </h1>
              <p className="crypto-trades-subtitle">
                Submitted by user after ticket closed.
              </p>
            </div>
          </div>

          {/* Stats Cards */}
          {/* <div className="crypto-trades-stats">
            <div className="stat-card">
              <div className="stat-icon total-trades-icon">
                <i className="fas fa-coins"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">{noOfPost}</h3>
                <p className="stats-label">Total Trades</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon image-trades-icon">
                <i className="fas fa-image"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">
                  {data.filter((item) => item.imageTitle).length}
                </h3>
                <p className="stats-label">With Images</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon video-trades-icon">
                <i className="fas fa-video"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">
                  {data.filter((item) => item.video).length}
                </h3>
                <p className="stats-label">With Videos</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon file-trades-icon">
                <i className="fas fa-file-alt"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">
                  {data.filter((item) => item.pdfFile).length}
                </h3>
                <p className="stats-label">With Files</p>
              </div>
            </div>
          </div> */}
        </div>

        {/* Table Section */}
        <div className="crypto-trades-table-container">
          <Table
            data={data}
            setPage={setPage}
            page={page}
            noOfPost={noOfPost}
            limit={limit}
            handleShowEdit={handleShowEdit}
          />
        </div>
      </div>

      {loader && <Loader />}
    </>
  );
}

const Table = ({ data, page, setPage, noOfPost, limit, handleShowEdit }) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const ratingMap = {
    5: { emoji: "😄", label: "Very Satisfied", color: "green" },
    4: { emoji: "🙂", label: "Satisfied", color: "#6bc06b" },
    3: { emoji: "😐", label: "Okay", color: "orange" },
    2: { emoji: "🙁", label: "Not Satisfied", color: "orangered" },
    1: { emoji: "😡", label: "Very Bad", color: "red" },
  };

  function RatingCell({ rating }) {
    const r = ratingMap[rating];
    return (
      <span style={{ color: r.color, fontWeight: 500 }}>
        {r.emoji} {r.label}
      </span>
    );
  }

  return (
    <>
      <div className="table-card">
        <div className="table-responsive">
          <table className="table crypto-trades-table">
            <thead>
              <tr>
                <th scope="col">Issue Id</th>
                <th scope="col">User</th>
                <th scope="col">Rating</th>
                <th scope="col">Feedback Message</th>
                <th scope="col">Closed By</th>
                <th scope="col">Subitted At</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, key) => (
                  <tr key={key} className="crypto-trade-row">
                    <td>{item?.issueId}</td>
                    <td>
                      <div className="creator-info">
                        <div className="creator-details">
                          <span className="creator-email">
                            {item?.userId?.email || "N/A"}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <RatingCell rating={item?.rating} />
                    </td>
                    <td>
                      <div className="description-container">
                        {item?.feedbackMessage ? (
                          <div
                            className="description-content"
                            dangerouslySetInnerHTML={{
                              __html: item?.feedbackMessage,
                            }}
                          />
                        ) : (
                          <div className="no-content-placeholder">
                            <i className="fas fa-align-left"></i>
                            <span>No Description</span>
                          </div>
                        )}
                      </div>
                    </td>

                    <td>
                      <div className="creator-info">
                        <div className="creator-avatar">
                          <i className="fas fa-user-circle"></i>
                        </div>
                        <div className="creator-details">
                          <span className="creator-email">
                            {item?.closedBy?.email || "N/A"}
                          </span>
                          <span className="creator-role">Support</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="date-info">
                        <div className="date-icon">
                          <i className="fas fa-calendar-alt"></i>
                        </div>
                        <div className="date-details">
                          <span className="date-formatted">
                            {formatDate(item?.createdAt)}
                          </span>
                          <span className="time-ago">
                            {moment(item?.createdAt).fromNow()}
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="no-data-row">
                  <td colSpan="7">
                    <div className="empty-state">
                      <div className="empty-state-icon">
                        <i className="fas fa-coins"></i>
                      </div>
                      <h3 className="empty-state-title">No Feedback Found</h3>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {data && data.length > 0 && noOfPost > limit && (
          <div className="pagination-container">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfPost / limit)}
                page={page}
                onChange={handleChange}
                color="primary"
                sx={{
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: "#10b981",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "#059669",
                    },
                  },
                  "& .MuiPaginationItem-root": {
                    "&:hover": {
                      backgroundColor: "#d1fae5",
                      color: "#059669",
                    },
                  },
                }}
              />
            </Stack>
          </div>
        )}
      </div>
    </>
  );
};

export default TicketFeedbackAdmin;
